import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleListDto } from '../../vehicles/dtos/vehicle-list.dto';
import { VehicleRoadWorthyCheckRecordCategoryEnum } from '../enums/vehicle-road-worthy-check-record-category.enum';
import { VehicleRoadWorthyCheckStatusEnum } from '../enums/vehicle-road-worthy-check-status.enum';

import { VehicleRoadWorthyCheckLinksDto } from './vehicle-road-worthy-check-links.dto';

/**
 * Vehicle road worthy check DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE_ROAD_WORTHY_CHECK)
export class VehicleRoadWorthyCheckListDto extends BaseDto {
  code!: string;
  externalReference?: string | null;
  startsAt!: Date;
  endsAt!: Date;
  status!: VehicleRoadWorthyCheckStatusEnum;
  recordCategory!: VehicleRoadWorthyCheckRecordCategoryEnum;
  vehicle?: VehicleListDto | null;
  taxRateType?: TaxRateTypeEnum | null;
  taxRate?: number | null;
  isTaxIncluded?: boolean | null;
  amount?: number | null;
  totalNet?: number | null;
  totalTax?: number | null;
  totalGross?: number | null;
  tags?: TagListDto[] | null;
  links?: VehicleRoadWorthyCheckLinksDto | null;
}
